// components 
import Vimeo from 'components/Vimeo.html'

// views
import PostContent from 'views/compounds/PostContent.html'
import PostMasonry from 'views/compounds/PostMasonry.html'
import PortfolioImage from 'views/compounds/PortfolioImage.html'

export default [
    // {
    //     id: "patreon",
    //     title: "Patreon",
    //     article: {
    //         component: PostContent,
    //         props: {
    //             title: "Patreon",
    //             subtitle: "",
    //             content: "Seit ich als 3D <i>generalist</i> arbeite, versuche ich die Abläufe in den verschiedenen Programmen über einfache <i>plugins</i> oder <i>scripts</i> zu vereinfachen.\nDiese sollen dabei fehlende Funktionalität hinzufügen, das Management von Projekten erleichtern oder das einhalten von Konventionen in Dateien und über verschiedene <i>artists</i> hinweg ermöglichen.\nMit der Zeit haben sich einige nützliche <i>plugins</i> angesammelt, die ich nun über meine Seite bei Patreon zur Verfügung stellen möchte.\nHier gelangt ihr zu den <i>plugins</i> und könnt mich bei der weiteren Entwicklung unterstützen: https://www.patreon.com/bernhardesperester",
    //             software: []
    //         }
    //     },
    //     aside: {
    //         component: PostMasonry,
    //         props: {
    //             template: "thumb1",
    //             items: [
    //                 {
    //                     area: "thumb1",
    //                     component: PortfolioImage,
    //                     props: {
    //                         url: "/img/patreon/header.jpg",
    //                         picture: {
    //                             format: 'cinemascope'
    //                         }
    //                     }
    //                 }
    //             ]
    //         }
    //     }
    // },
    {
        id: "showreel-2018",
        title: "Breakdown",
        article: {
            component: PostContent,
            props: {
                title: "Showreel 2018",
                subtitle: "",
                content: "Das Showreel 2018 besteht aus einer Auswahl von Projekten, an denen ich im Zeitraum von 2013 - 2018 mitgewirkt habe, z. B. <strong>Avengers: Age of Ultron</strong> oder <strong>Captain America: Civil War</strong>.",
                software: []
            }
        },
        aside: {
            component: Vimeo,
            props: {
                videoId: "265553503"
            }
        },        
        posts: [
            {
                id: "spellwork-batman",
                title: "Spellwork Batman Arkham VR",
                article: {
                    component: PostContent,
                    props: {
                        title: "Batman: Arkham VR",
                        subtitle: "2016, Spellwork GmbH",
                        content: "In dieser Produktion arbeitete ich an der ikonischen Maske des schwarzen Ritters aka. Batman. Dieses 3D Modell wurde für den Trailer zum Spiel <strong>Batman: Arkham VR</strong> zur E3 2016 gestaltet.\nMein Schwerpunkt lag hierbei in <i>sculpting</i> und <i>texturing</i>.",
                        software: ['maya', 'zbrush', 'mari']
                    }
                },
                aside: {
                    component: PostMasonry,
                    props: {
                        template: "thumb1 thumb1 thumb1|thumb2 thumb3 thumb4",
                        items: [
                            {
                                area: "thumb1",
                                component: PortfolioImage,
                                props: {
                                    url: "/img/showreel-2018/spellwork-batman-004.jpg",
                                    picture: {
                                        format: 'cinemascope'
                                    }
                                }
                            },
                            {
                                area: "thumb2",
                                component: PortfolioImage,
                                props: {
                                    url: "/img/showreel-2018/spellwork-batman-002.jpg",
                                    picture: {
                                        format: 'cinemascope'
                                    }
                                }
                            },
                            {
                                area: "thumb3",
                                component: PortfolioImage,
                                props: {
                                    url: "/img/showreel-2018/spellwork-batman-001.jpg",
                                    picture: {
                                        format: 'cinemascope'
                                    }
                                }
                            },
                            {
                                area: "thumb4",
                                component: PortfolioImage,
                                props: {
                                    url: "/img/showreel-2018/spellwork-batman-003.jpg",
                                    picture: {
                                        format: 'cinemascope'
                                    }
                                }
                            }
                        ]
                    }
                }
            },
            {
                id: "risefx-avengers",
                title: "RISE FX Avengers: Age of Ultron",
                article: {
                    component: PostContent,
                    props: {
                        title: "Avengers: Age of Ultron",
                        subtitle: "2015, RISE FX GmbH",
                        content: "In Zusammenarbeit mit <strong>RISE FX GmbH</strong> entstand 2015 die Produktion <strong>Avengers: Age of Ultron</strong>. In diesem Film aus dem Marvel Cinematic Universe arbeitete ich an verschiedenen <i>assets</i> für das <i>environment</i> z. B. ein digitaler Berg für eine <i>setextension</i>, oder einem einstürzenden Boden aus Pflastersteinen sowie an einem <i>full-cg shot</i> bei dem ich maßgeblich am Design, <i>sculpting</i>, <i>texturing</i> und <i>shading</i> beteiligt war.",
                        software: ['maya', 'zbrush', 'houdini', 'mari']
                    }
                },
                aside: {
                    component: PostMasonry,
                    props: {
                        template: "thumb1 thumb1|thumb2 thumb3",
                        items: [
                            {
                                area: "thumb1", 
                                component: PortfolioImage,
                                props: {
                                    url: "/img/showreel-2018/risefx-avengers-001.jpg",
                                    picture: {
                                        format: 'cinemascope'
                                    }
                                }
                            },
                            {
                                area: "thumb2", 
                                component: PortfolioImage,
                                props: {
                                    url: "/img/showreel-2018/risefx-avengers-002.jpg",
                                    picture: {
                                        format: 'cinemascope'
                                    }
                                }
                            },
                            {
                                area: "thumb3",
                                component: PortfolioImage,
                                props: {
                                    url: "/img/showreel-2018/risefx-avengers-003.jpg",
                                    picture: {
                                        format: 'cinemascope'
                                    }
                                }
                            }
                        ]
                    }
                }
            },
            {
                id: "spellwork-vwamarok",
                title: "VW Amarok",
                article: {
                    component: PostContent,
                    props: {
                        title: "VW Amarok",
                        subtitle: "2016, Spellwork GmbH",
                        content: "Für dieses Projekt habe ich verschiedene <i>assets</i> wie Stahlträger und Türen für das <i>environment</i> texturiert, eine detailierte Version des Betonbodens erstellt und einige <i>3D scans</i> von Industrieböden aufgearbeitet.",
                        software: ['maya', 'zbrush', 'mari', 'photoscan']
                    }
                },
                aside: {
                    component: PostMasonry,
                    props: {
                        template: "thumb1 thumb2|thumb3 thumb3",
                        items: [
                            {
                                area: "thumb1",
                                component: PortfolioImage,
                                props: {
                                    url: "/img/showreel-2018/spellwork-vwamarok-002.jpg",
                                    picture: {
                                        format: 'cinemascope'
                                    }
                                }
                            },
                            {
                                area: "thumb2",
                                component: PortfolioImage,
                                props: {
                                    url: "/img/showreel-2018/spellwork-vwamarok-004.jpg",
                                    picture: {
                                        format: 'cinemascope'
                                    }
                                }
                            },
                            {
                                area: "thumb3",
                                component: PortfolioImage,
                                props: {
                                    url: "/img/showreel-2018/spellwork-vwamarok-001.jpg",
                                    picture: {
                                        format: 'cinemascope'
                                    }
                                }
                            }
                        ]
                    }
                }
            },
            {
                id: "royalpenguins-history",
                title: "History of Violence",
                article: {
                    component: PostContent,
                    props: {
                        title: "Von der Keule zur Rakete - Die Geschichte der Gewalt",
                        subtitle: "2017-2018, RoyalPenguins GbR",
                        content: "Für dieses umfangreiche Projekt des <strong>ZDF: Von der Keule zur Rakete - Die Geschichte der Gewalt</strong> habe ich mehrere digitale Menschen in Kampfhandlungen mit variierenden Kostümen nach historischen Vorlagen erstellt. Meine Schwerpunkte lagen hier bei <i>modeling</i>, <i>sculpting</i>, <i>texturing</i>, <i>rigging</i> und <i>animation</i>.",
                        software: ['cinema4d', 'zbrush', 'mari', 'nuke']
                    }
                },
                aside: {
                    component: PostMasonry,
                    props: {
                        template: "thumb1",
                        items: [
                            {
                                area: "thumb1",
                                component: PortfolioImage,
                                props: {
                                    url: "/img/showreel-2018/royalpenguins-history-001.jpg",
                                    picture: {
                                        format: 'cinemascope'
                                    }
                                }
                            }
                        ]
                    }
                }
            },
            {
                id: "risefx-bookthief",
                title: "The Bookthief",
                article: {
                    component: PostContent,
                    props: {
                        title: "The Bookthief",
                        subtitle: "2013, RISE FX GmbH",
                        content: "In Zusammenarbeit mit <strong>RISE FX GmbH</strong> an <strong>The Bookthief</strong> arbeitete ich an der realistischen und physikalisch korrekten Simulation, digitale Häuser einstürzen zu lassen, sodass diese in ihre Einzelteile zerfallen. Hierfür lagen meine Schwerpunkte, besonders für das Erstellen der Ziegel, Balken und Schindeln in <i>modeling</i>, <i>retopology</i>, <i>sculpting</i> und <i>texturing</i>.",
                        software: ['maya', 'zbrush', 'mari']
                    }
                },
                aside: {
                    component: PostMasonry,
                    props: {
                        template: "thumb1",
                        items: [
                            {
                                area: "thumb1",
                                component: PortfolioImage,
                                props: {
                                    url: "/img/showreel-2018/risefx-bookthief-004.jpg",
                                    picture: {
                                        format: 'cinemascope'
                                    }
                                }
                            }
                        ]
                    }
                }
            },
            {
                id: "risefx-muenze",
                title: "Münze Österreich",
                article: {
                    component: PostContent,
                    props: {
                        title: "Münze Österreich: Lebendige Urzeit Kreide - Leben auf der Erde",
                        subtitle: "2013, RISE FX GmbH",
                        content: "Für einen Werbespot für <strong>Münze Österreich: Lebendige Urzeit Kreide - Leben auf der Erde</strong> in Zusammenarbeit mit <strong>RISE FX GmbH</strong> arbeitete ich maßgebend an einem sich nach der Sammlermünze aufbäumenden Struthiosaurus.\n Dabei entwickelte ich im Team die Kurzgeschichte für den Ablauf der Handlung sowie die Kamerafahrt. Meine Aufgabe bestand aus <i>modeling</i>, <i>sculpting</i>, <i>texturing</i>, <i>shading</i>, <i>lighting</i> und <i>animation</i> für den vierbeinigen Dinosaurier.",
                        software: ['maya', 'zbrush', 'mari']
                    }
                },
                aside: {
                    component: PostMasonry,
                    props: {
                        template: "thumb1",
                        items: [
                            {
                                area: "thumb1",
                                component: PortfolioImage,
                                props: {
                                    url: "/img/showreel-2018/risefx-muenze-001.jpg",
                                    picture: {
                                        format: 'cinemascope'
                                    }
                                }
                            }
                        ]
                    }
                }
            },
            {
                id: "spellwork-mercedes",
                title: "Mercedes",
                article: {
                    component: PostContent,
                    props: {
                        title: "Mercedes",
                        subtitle: "2015, Spellwork GmbH",
                        content: "Für dieses Projekt mit der Firma <strong>Spellwork GmbH</strong> habe ich mehrere <i>3D scans</i> von schottischen Burganlagen und Vegetation aufbereitet. Zusätzlich arbeitete ich an der realistischen Darstellung des Asphalts der Straße, auf dem das Auto im <i>heroshot</i> detailliert zu sehen ist.",
                        software: ['maya', 'zbrush', 'mari', 'photoscan']
                    }
                },
                aside: {
                    component: PostMasonry,
                    props: {
                        template: "thumb1 thumb2|thumb3 thumb3",
                        items: [
                            {
                                area: "thumb1",
                                component: PortfolioImage,
                                props: {
                                    url: "/img/showreel-2018/spellwork-mercedes-001.jpg",
                                    picture: {
                                        format: 'cinemascope'
                                    }
                                }
                            },
                            {
                                area: "thumb2",
                                component: PortfolioImage,
                                props: {
                                    url: "/img/showreel-2018/spellwork-mercedes-002.jpg",
                                    picture: {
                                        format: 'cinemascope'
                                    }
                                }
                            },
                            {
                                area: "thumb3",
                                component: PortfolioImage,
                                props: {
                                    url: "/img/showreel-2018/spellwork-mercedes-003.jpg",
                                    picture: {
                                        format: 'cinemascope'
                                    }
                                }
                            }
                        ]
                    }
                }
            },
            {
                id: "risefx-captain",
                title: "Captain America: Civil War",
                article: {
                    component: PostContent,
                    props: {
                        title: "Captain America: Civil War",
                        subtitle: "2015 / 2016, RISE FX GmbH",
                        content: "Für ein weiteres Marvel Projekt arbeitete ich erneut mit <strong>RISE FX GmbH</strong>. Hierbei habe ich mehrere <i>3D scans</i> von Marktständen aufbereitet, Umgebungsgegenstände wie Lampen, Strommasten oder Warentische hergestellt und <i>setextensions</i> wie digitale Schildern zur Erweiterung des Sets gebaut.\nAußerdem war ich maßgeblich an der Herstellung einer digitalen Menschenmenge für die <i>crowd simulation</i> beteiligt. Zusätzlich arbeitete ich an dem <i>digi-double</i> des Antagonisten <strong>\"Crossbone\"</strong> mit, indem ich prominente Teile seines Rüstung z. B. seinen Brustpanzer, Knieschoner und Handschuhe herstellte.\nAufbauend darauf habe ich für einige <i>shots</i> das <i>matchmoving</i> der Handschuhe und des Schildes von <strong>Captain America</strong> übernommen, sowie <i>mattepaintings</i> für die Hintergründe erstellt.",
                        software: ['maya', 'zbrush', 'houdini', 'mari', 'photoscan', 'photoshop']
                    }
                },
                aside: {
                    component: PostMasonry,
                    props: {
                        template: "thumb2 thumb2 thumb1|thumb2 thumb2 thumb3|thumb4 thumb5 thumb6",
                        items: [
                            {
                                area: "thumb1",
                                component: PortfolioImage,
                                props: {
                                    url: "/img/showreel-2018/risefx-captain-001.jpg",
                                    picture: {
                                        format: 'cinemascope'
                                    }
                                }
                            },
                            {
                                area: "thumb2",
                                component: PortfolioImage,
                                props: {
                                    url: "/img/showreel-2018/risefx-captain-002.jpg",
                                    picture: {
                                        format: 'cinemascope'
                                    }
                                }
                            },
                            {
                                area: "thumb3",
                                component: PortfolioImage,
                                props: {
                                    url: "/img/showreel-2018/risefx-captain-003.jpg",
                                    picture: {
                                        format: 'cinemascope'
                                    }
                                }
                            },
                            {
                                area: "thumb4",
                                component: PortfolioImage,
                                props: {
                                    url: "/img/showreel-2018/risefx-captain-004.jpg",
                                    picture: {
                                        format: 'cinemascope'
                                    }
                                }
                            },
                            {
                                area: "thumb5",
                                component: PortfolioImage,
                                props: {
                                    url: "/img/showreel-2018/risefx-captain-005.jpg",
                                    picture: {
                                        format: 'cinemascope'
                                    }
                                }
                            },
                            {
                                area: "thumb6",
                                component: PortfolioImage,
                                props: {
                                    url: "/img/showreel-2018/risefx-captain-006.jpg",
                                    picture: {
                                        format: 'cinemascope'
                                    }
                                }
                            }
                        ]
                    }
                }
            },
            {
                id: "risefx-borgia",
                title: "Borgia Season 3",
                article: {
                    component: PostContent,
                    props: {
                        title: "Borgia Season 3",
                        subtitle: "2013, RISE FX GmbH",
                        content: "In wiederholter Zusammenarbeit mit <strong>RISE FX GmbH</strong> entstand die letzte Staffel der TV-Serie Borgia.\nIm Zuge der Herstellung von voll zerstörbaren Wehrmauern und verschiedenen <i>assets</i> wie Pfeile und Zirkel lagen meine Schwerpunkte in <i>modeling</i>, <i>sculpting</i>, <i>texturing</i> und <i>matchmoving</i>.",
                        software: ['maya', 'zbrush', 'mari', 'photoscan']
                    }
                },
                aside: {
                    component: PostMasonry,
                    props: {
                        template: "thumb1",
                        items: [
                            {
                                area: "thumb1",
                                component: PortfolioImage,
                                props: {
                                    url: "/img/showreel-2018/risefx-borgia-001.jpg",
                                    picture: {
                                        format: 'cinemascope'
                                    }
                                }
                            }
                        ]
                    }
                }
            }
        ]
    },
    {
        id: "wip-dragon",
        title: "Breakdown",
        article: {
            component: PostContent,
            props: {
                title: "WIP: Dragon",
                subtitle: "",
                content: "Ein aktuelles Projekt, bei dem ich mich mit den neuesten <i>features</i> der neuen zBrush-Version auseinandersetze und mich auf das 3D Design und organisches <i>sculpting</i> von Kreaturen konzentriere, zeigt die Herstellung eines Drachen nach westlichen Vorbildern z. B. Game of Thrones oder der Hobbit.",
                software: []
            }
        },
        aside: {
            component: PostMasonry,
            props: {
                template: "thumb1",
                items: [
                    {
                        area: "thumb1",
                        component: PortfolioImage,
                        props: {
                            url: "/img/wip-dragon/wip-dragon-001.jpg"
                        }
                    }
                ]
            }
        },
        posts: [
            {
                id: "wip-dragon-progress",
                title: "Progress",
                article: {
                    component: PostContent,
                    props: {
                        title: "Progress",
                        subtitle: "",
                        content: "Im Fokus steht hierbei die plastische Darstellung von organischen Formen und Falten ohne Zuhilfenahme von vorgefertigten <i>settings</i>.",
                        software: ['zbrush']
                    }
                },
                aside: {
                    component: PostMasonry,
                    props: {
                        template: "thumb3 thumb3|thumb1 thumb2",
                        items: [
                            {
                                area: "thumb1",
                                component: PortfolioImage,
                                props: {
                                    url: "/img/wip-dragon/wip-dragon-002.jpg"
                                }
                            },
                            {
                                area: "thumb2",
                                component: PortfolioImage,
                                props: {
                                    url: "/img/wip-dragon/wip-dragon-003.jpg"
                                }
                            },
                            {
                                area: "thumb3",
                                component: PortfolioImage,
                                props: {
                                    url: "/img/wip-dragon/wip-dragon-004.jpg"
                                }
                            }
                        ]
                    }
                }
            }
        ]
    },
    {
        id: "the-ancient-ones",
        title: "Breakdown",
        article: {
            component: PostContent,
            props: {
                title: "The Ancient Ones",
                subtitle: "",
                content: "Im Fokus dieser Arbeit stand das Wirkungsgefüge von Modell und Hintergrund zu einem Gesamtprodukt. Die Herstellung der Fantasy-Kreatur erforderte besonders die Teilbereiche <i>sculpting</i>, <i>texturing</i>, <i>shading</i> und <i>lighting</i>. Ziel dieser Arbeit war das Herausstellen einer Atmosphäre die den Betrachter sowohl einlädt als auch bedrohend wirkt.",
                software: []
            }
        },
        aside: {
            component: PostMasonry,
            props: {
                template: "thumb1",
                items: [
                    {
                        area: "thumb1",
                        component: PortfolioImage,
                        props: {
                            url: "/img/the-ancient-ones/the-ancient-ones-hero.jpg",
                            picture: {
                                poiX: 75, 
                                poiY: 25
                            }
                        }
                    }
                ]
            }
        },
        posts: [
            {
                id: "the-ancient-ones-progress",
                title: "Progress",
                article: {
                    component: PostContent,
                    props: {
                        title: "Progress",
                        subtitle: "",
                        content: "Für <i>modeling</i>, <i>rigging</i> und <i>posing</i> wurde Cinema 4D verwendet; das <i>sculpting</i> und <i>texturing</i> entstand in zBrush. Die Texturen wurden anschließend in Photoshop aufbereitet.\nFür das <i>rendering</i> arbeitete ich in vRay und für das <i>compositing</i> in AfterEffects.",
                        software: ['cinema4d', 'photoshop', 'zbrush', 'aftereffects']
                    }
                },
                aside: {
                    component: PostMasonry,
                    props: {
                        template: "thumb5 thumb5 thumb5 thumb5|thumb1 thumb2 thumb3 thumb4",
                        items: [
                            {
                                area: "thumb4",
                                component: PortfolioImage,
                                props: {
                                    url: "/img/the-ancient-ones/the-ancient-ones-diffuse.jpg"
                                }
                            },
                            {
                                area: "thumb1",
                                component: PortfolioImage,
                                props: {
                                    url: "/img/the-ancient-ones/the-ancient-ones-002.jpg"
                                }
                            },
                            {
                                area: "thumb2",
                                component: PortfolioImage,
                                props: {
                                    url: "/img/the-ancient-ones/the-ancient-ones-003.jpg"
                                }
                            },
                            {
                                area: "thumb3",
                                component: PortfolioImage,
                                props: {
                                    url: "/img/the-ancient-ones/the-ancient-ones-004.jpg",
                                    picture: {
                                        poiX: 75, poiY: 10
                                    }
                                }
                            },
                            {
                                area: "thumb5",
                                component: PortfolioImage,
                                props: {
                                    url: "/img/the-ancient-ones/the-ancient-ones-005.jpg",
                                    picture: {
                                        poiX: 75, poiY: 10
                                    }
                                }
                            }
                        ]
                    }
                }
            },
            {
                id: "the-ancient-ones-props",
                title: "Props",
                article: {
                    component: PostContent,
                    props: {
                        title: "Props",
                        subtitle: "",
                        content: "Für das Projekt habe ich sämtliche Gegenstände wie zum Beispiel Bücher, Kerzen und Papier erstellt.",
                        software: []
                    }
                },
                aside: {
                    component: PostMasonry,
                    props: {
                        template: "thumb1",
                        items: [
                            {
                                area: "thumb1",
                                component: PortfolioImage,
                                props: {
                                    url: "/img/the-ancient-ones/the-ancient-ones-books.jpg"
                                }
                            }
                        ]
                    }
                }
            }
        ]
    }
]